import { ButtonProps, RadioGroup, FormControlLabel, Link } from '@mui/material';
import { Button as MuiButton, Popover } from '@mui/material';
import styled from 'styled-components';

export const AppContainer = styled.div`
  text-align: center;
  background-size: contain;
`;

// Estilos da .navbar
export const Navbar = styled.div`
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
`;

// Estilos da .sidebar
export const Sidebar = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  /* padding: 48px 0 0; */
  box-shadow: inset -1px 0 0 rgb(0 0 0 / 10%);
`;

// Estilos da .sidebar ul
export const SidebarUl = styled.ul`
  padding-top: 1rem;
`;

// Estilos dos botões dentro da .sidebar
export const SidebarButton = styled.button`
  background-color: transparent;
  border: none;
  color: #fff;
  box-shadow: none;
`;

// Estilos da .sub .nav-link
export const SubNavLink = styled.div`
  padding-left: 2rem !important;
`;

// Estilos da .sub
export const Sub = styled.div`
  padding-top: 0 !important;
`;

// Estilos do ícone de seta
export const NavArrow = styled.div`
  display: inline-block;
  margin-left: auto;
`;

// Estilos do ícone SVG dentro do .nav-arrow
export const NavArrowSVG = styled.svg`
  transition: transform 0.15s ease;
`;

// Estilos específicos do ícone SVG dentro da .sidebar .nav-link
export const SidebarNavArrowSVG = styled(NavArrowSVG)`
  transform: rotate(-90deg);
`;

// Estilos específicos do ícone SVG dentro da .sidebar .nav-link.collapsed
export const SidebarNavArrowSVGCollapsed = styled(NavArrowSVG)`
  transform: rotate(0deg);
`;

// Estilos dos botões dentro da .account-link
export const AccountLinkButton = styled.button`
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
`;

// Estilos da .nav-link
export const NavLink = styled.div`
  color: hsl(0deg 0% 0% / 55%);

  &:hover,
  &:focus {
    color: hsl(0deg 0% 0% / 77%);
  }
`;

// Estilos dos .sidebar .nav-item .nav-link
export const SidebarNavLink = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  padding: 1rem;
  transition: 0.4s;

  &.active {
    font-weight: 700;
  }

  &:hover {
    opacity: 0.8;
  }
`;

// Estilos do ícone SVG dentro da .sidebar .nav-item .nav-link
export const SidebarNavLinkSVG = styled.svg`
  font-size: 0.95rem;
  margin-right: 0.3rem;
`;

// Estilos do hr dentro da .sidebar
export const SidebarHR = styled.hr`
  color: #fbfbfb61;
`;

// Estilos para a .sidebar com media query
export const SidebarMediaQuery = styled(Sidebar)`
  @media (max-width: 768px) {
    padding: 48px 0 0;
  }
`;

// Estilos da .sidebar-brand
export const SidebarBrand = styled.a`
  text-decoration: none;
  font-size: 1rem;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  z-index: 1;
`;

// Estilos do .navbar-toggler
export const NavbarToggler = styled.div`
  margin-left: 1rem;
`;

// Estilos para a .dropdown-item.active e .dropdown-menu-dark .dropdown-item.active
export const DropdownItemActive = styled.div`
  color: #3c8dbc !important;
  background-color: transparent;
  pointer-events: none;
`;

// Estilos para a .dropdown-item
export const DropdownItem = styled.div`
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #3a3b45;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  display: flex;
  align-items: center;
`;

// Estilos para a .App-header
export const AppHeader = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  overflow: auto;
`;

// Estilos para a .App-link
export const AppLink = styled.a`
  color: #61dafb;
`;

// Estilos para os botões dentro de .buttons
export const ButtonsButton = styled.button`
  margin: 0 10px 10px 0;
`;

// Estilos para a animação de giro do logo dentro de @keyframes App-logo-spin
export const AppLogoSpin = styled.div`
  @keyframes App-logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const Container = styled.div`
  text-align: center;
  background-attachment: fixed;
  background-position: center center;
  background-repeat: repeat-y;
  background-size: cover;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  overflow: auto;
`;

export const Content = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25px;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  overflow: auto;

  & > div {
    width: 100%;
    max-width: 360px;
  }
`;

// Estilos do .card
export const Card = styled.div`
  word-wrap: break-word;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.7rem;
  display: flex;
  flex-direction: column;
  min-width: 0;
  position: relative;
  text-align: left;

  &:last-child {
    margin-bottom: 2.2rem;
  }
`;

// Estilos do .card-header
export const CardHeader = styled.div`
  background-color: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  text-align: center;
  margin-bottom: 0;
  padding: 1.5rem;

  &:first-child {
    border-radius: calc(0.7rem - 1px) calc(0.7rem - 1px) 0 0;
  }

  font-size: 1.2rem;
  font-weight: 700;
`;

// Estilos do .card-body
export const CardBody = styled.div`
  flex: 1 1 auto;
  padding: 1rem;
`;

// Estilos do .card-footer
export const CardFooter = styled.div`
  background-color: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  padding: 1.5rem;

  &:last-child {
    border-radius: 0 0 calc(0.7rem - 1px) calc(0.7rem - 1px);
  }
`;

// Estilos para .card-img-top
export const CardImgTop = styled.div`
  border-top-left-radius: calc(0.7rem - 1px);
  border-top-right-radius: calc(0.7rem - 1px);
`;

// Estilos para .card-img-bottom
export const CardImgBottom = styled.div`
  border-bottom-left-radius: calc(0.7rem - 1px);
  border-bottom-right-radius: calc(0.7rem - 1px);
`;

// Estilos para .card-img-overlay + .card-img
export const CardImgOverlay = styled.div`
  border-radius: calc(0.7rem - 1px);
`;

// Estilos para .card.login
export const CardLogin = styled(Card)`
  margin: 40px auto;
  max-width: 500px;
  background-color: transparent;
  border: none;
`;

// Estilos para .login .card-body
export const LoginCardBody = styled(CardBody)`
  padding: 1.25rem !important;
  background-color: white !important;
`;

// Estilos para .login .card-header
export const LoginCardHeader = styled(CardHeader)`
  margin-top: 20px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`;

// Estilos para .login .card-footer
export const LoginCardFooter = styled(CardFooter)`
  background-color: white !important;
  border-bottom-left-radius: 20px !important;
  border-bottom-right-radius: 20px !important;
  border-top: none;
  a {
    font-size: 16px;
  }
`;

// Estilos para .login .card-footer a
export const LoginCardFooterLink = styled.a`
  font-size: 16px;
`;

// Estilos para .form-label
export const FormLabel = styled.label`
  font-size: 18px;
`;

// Estilos para .login-logo
export const LoginLogo = styled.div`
  text-align: center;
`;

// Estilos para .App-logo
export const AppLogo = styled.img`
  display: block;
  max-width: 100%;
  height: auto;
`;

// Estilos para .bg-info e .bg-info > a
export const BgInfo = styled.div`
  color: #fff !important;
`;

// Estilos para .bg-success e .bg-success > a
export const BgSuccess = styled.div`
  color: #fff !important;
`;

// Estilos para .bg-primary e .bg-primary > a
export const BgPrimary = styled.div`
  color: #fff !important;
`;

// Estilos para .bg-danger e .bg-danger > a
export const BgDanger = styled.div`
  color: #fff !important;
`;

// Estilos para .bg-warning e .bg-warning > a
export const BgWarning = styled.div`
  color: #000 !important;
`;

// Estilos para .bg-secondary e .bg-secondary > a
export const BgSecondary = styled.div`
  color: #000 !important;
`;

// Estilos para .small-box
export const SmallBox = styled.div`
  border-radius: 0.25rem;
  box-shadow: 0 0 1px rgb(0 0 0 / 13%), 0 1px 3px rgb(0 0 0 / 20%);
  display: block;
  margin-bottom: 20px;
  position: relative;
  text-align: left;
`;

// Estilos para .small-box .inner
export const SmallBoxInner = styled.div`
  padding: 10px;
`;

// Estilos para .small-box h3
export const SmallBoxH3 = styled.h3`
  font-size: 2.2rem;
  font-weight: 700;
  margin: 0 0 10px;
  padding: 0;
  white-space: nowrap;
`;

// Estilos para .small-box p
export const SmallBoxP = styled.p`
  font-size: 1rem;
`;

// Estilos para .small-box .icon
export const SmallBoxIcon = styled.div`
  color: rgba(0, 0, 0, 0.15);
  z-index: 0;
`;

// Estilos para .small-box .small-box-footer
export const SmallBoxFooter = styled.div`
  background-color: rgba(0, 0, 0, 0.1);
  color: rgba(255, 255, 255, 0.5);
  display: block;
  padding: 3px 0;
  position: relative;
  text-align: center;
  text-decoration: none;
  z-index: 10;
  transition: 0.4s;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.15);
    color: #fff;
  }
`;

// Estilos para .modal-content
export const ModalContent = styled.div`
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  display: flex;
  flex-direction: column;
  outline: 0;
  pointer-events: auto;
  position: relative;
  width: 100%;

  .modal & {
    border: none;
    box-shadow: -8px 12px 18px 0 rgb(25 42 70 / 13%);
  }
`;

// Estilos para .modal-header
export const ModalHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  padding: 1rem;
`;

// Estilos para .modal-footer
export const ModalFooter = styled.div`
  padding: 1rem;
`;

// Estilos para .MuiRadio-colorSecondary.Mui-checked
export const MuiRadioColorSecondaryChecked = styled.div`
  color: #1976d2 !important;
`;

// Estilos para .MuiRadio-colorSecondary.Mui-checked:hover e .MuiIconButton-colorSecondary:hover
export const MuiRadioColorSecondaryCheckedHover = styled.div`
  background-color: rgba(91, 189, 172, 0.04) !important;
`;

// Estilos para .needs-validation
export const NeedsValidation = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

// Estilos para .needs-validation-grid
export const NeedsValidationGrid = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

// Estilos para .person-type-wrapper
export const PersonTypeWrapper = styled.div`
  display: grid;
  grid-column: span 2;
`;

// Estilos para .span-2
export const Span2 = styled.div`
  grid-column: span 2;
`;

// Estilos para .person-type-wrapper .MuiFormGroup-root
export const PersonTypeFormGroup = styled(RadioGroup)`
  width: 100%;
  display: flex;
  flex-direction: row !important;
  align-items: center;
  gap: 20px;
`;

export const UsernameText = styled.span`
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const UserMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 10px;
`;

export const GlassPopover = styled(Popover)`
  z-index: 99999 !important;
  min-width: 200px !important;

  & .MuiPaper-root {
    background-color: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(14px);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.25);
  }

  & button {
    justify-content: flex-start;
  }
`;

// Estilos para .MuiFormControlLabel-root
export const PersonTypeControlLabel = styled(FormControlLabel)`
  margin-right: 0 !important;
  color: rgba(0, 0, 0, 0.54);

  .MuiRadio-colorSecondary.Mui-checked {
    color: #1976d2 !important;

    &:hover, /* Estilos para quando o radio está selecionado e o cursor passa por cima */
    .MuiIconButton-colorSecondary:hover {
      background-color: rgba(91, 189, 172, 0.04) !important;
    }
  }
`;

// Estilos para .css-1c3trtb-MuiPaper-root-MuiAlert-root
export const Css1c3trtbMuiPaperRootMuiAlertRoot = styled.div`
  background-color: #fb6054 !important;
`;

export const MuiButtonRoundedSuccess = styled(MuiButton)<ButtonProps>`
  background-color: #40e08d !important;
  color: #fff !important;
  border-radius: 999999px !important;
  font-weight: 600 !important;

  &:hover {
    background-color: #31cb7b !important;
  }
`;

export const MuiButtonRoundedError = styled(MuiButton)<ButtonProps>`
  background-color: #ff6949 !important;
  color: #fff !important;
  border-radius: 999999px !important;
  font-weight: 600 !important;

  &:hover {
    background-color: #ee4c28 !important;
  }
`;

// Estilos para .MuiContainer-root
export const MuiContainerRoot = styled.div`
  padding: 0 !important;
`;

export const MaterialLink = styled(Link)`
  font-size: 1rem !important;
  color: #3c8dbc !important;
`;
